import { Component, OnInit, EventEmitter, Output, HostListener, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogTipo } from 'src/app/custom-components/dialog/utils/dialog-type.enum';
import { DialogComponent } from 'src/app/custom-components/dialog/dialog.component';
import { DialogConfig } from 'src/app/custom-components/dialog/interfaces/dialog-config.interface';
import { Color } from 'src/app/utils/color.enum';
import { Router } from '@angular/router';
import { PasswordResetComponent } from 'src/app/password-reset/password-reset.component';
import { ToolbarService } from './toolbar.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { mergeMap, mergeMapTo, debounceTime } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';


@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit {
  // textos
  appNameMsg = 'NEGOFIN';
  logoutMsg = 'Cerrar sesión';
  moduleName = '';

  @Output() toggle: EventEmitter<any> = new EventEmitter();
  @ViewChild('scrollableElement') viewport: CdkVirtualScrollViewport

  variable: any = [];
  notificaciones: any = [];
  mostrarDashboardBtn = false;
  paginacion: any = {
    pagina: 1,
    cantItems: 10
  };
  reachedEnd = false;
  variablePagina: any;
  total: number = 0;
  finalNotificacion: boolean = false;
  sinNotificacion: boolean = false;
  menuabierto: boolean = false
  redireccion: any;


  constructor(private dialog: MatDialog, private router: Router, private toolbarService: ToolbarService
    ,private snackbar: MatSnackBar, private afMessaging: AngularFireMessaging,
    private loaderService: LoaderService) {
    this.mostrarDashboardBtn = false;
    const paths = router.url.split('/');
    if (paths[1] === 'entidad') {
      this.mostrarDashboardBtn = true;
    }
    this.requestPermission();
    this.getToken();
  }

  ngOnInit(): void {
    const urlList = this.router.routerState.snapshot.url.split('/');
    if(urlList.length == 3){
      if (urlList[1] === 'entidad' && urlList[2] === 'inicio') {
        this.moduleName = urlList[1].toUpperCase();

        this.toolbarService.setModuleNamePrev(this.moduleName);
      }else if (urlList[1] === 'procesadora') {
        this.moduleName = urlList[1].toUpperCase();
        this.toolbarService.setModuleNamePrev(this.moduleName);
      }
      else{
        this.moduleName = this.toolbarService.getModuleNamePrev();
      }
    }
    else if(urlList.length == 2){
      if (urlList[1] === 'procesadora') {
        this.moduleName = urlList[1].toUpperCase();

        this.toolbarService.setModuleNamePrev(this.moduleName);
      }
      else{
        this.moduleName = this.toolbarService.getModuleNamePrev();
      }
    }
    else{
      this.moduleName = this.toolbarService.getModuleNamePrev();
    }

    // this.obtenerCantidadNotificacion();
    // this.timerCantidadNotificacion();

  }

  touchToggle(): void {
    this.toggle.emit();
  }

  openDialog(): void {
    const data: DialogConfig = {
      tipo: DialogTipo.INFO,
      toolbarColor: 'primary',
      toolbarTitulo: 'Atención',
      toolbarIcono: 'warning',
      mensaje: 'Su sesión ha expirado, por favor, vuelva a iniciar sesión',
      aceptarBtn: { texto: 'Entendido', color: Color.PRIMARY },
    };

    const dialogRef = this.dialog.open(DialogComponent, {
      minWidth: '300px',
      role: 'alertdialog',
      data,
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  openConfirmDialog(): void {
    const data: DialogConfig = {
      tipo: DialogTipo.CONFIRM,
      toolbarColor: 'primary',
      toolbarTitulo: 'Atención',
      toolbarIcono: 'warning',
      mensaje: 'Su sesión ha expirado, por favor, vuelva a iniciar sesión',
      aceptarBtn: { texto: 'Entendido', color: Color.PRIMARY },
    };

    const dialogRef = this.dialog.open(DialogComponent, {
      minWidth: '300px',
      role: 'alertdialog',
      data,
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['login']);
  }

  cambiarPassword() {
    const dialog = this.dialog.open(PasswordResetComponent, {
      maxHeight: 600,
      maxWidth: 600,
      data: {
        loginPage: true
      }
    });

    dialog.afterClosed();
    return;
  }

  //metodo para obtener el total de notificaciones pendientes de lectura
  obtenerCantidadNotificacion() {
    this.toolbarService.contarNotificacion()
        .subscribe(
            data => {
              this.variable = data;
            });
            this.loaderService.hideLoader();
}
//metodo para obtener el listado de las notificaciones que reciben los usuarios
obtenerNotificaciones(){

  this.toolbarService.obtenerNotificaciones(this.paginacion)
        .subscribe({
            next:(res: any) => {
              this.snackbar.dismiss();
              this.menuabierto = true
              if(res.length != 0){
              const currentScrollOffset = this.viewport.measureScrollOffset();
              this.notificaciones = [...this.notificaciones, ...res.data]
              this.variablePagina = res.pagination
              this.total = res.pagination.por_pagina
              console.log("total ", this.notificaciones.length)
              if(this.notificaciones.length > 10){
                setTimeout(() => {
                  this.viewport.checkViewportSize();
                  this.viewport.scrollToOffset(currentScrollOffset + 200, 'smooth');
                }, 200)
              }
            }else{
              if(res.length === 0){
                this.sinNotificacion = true;
              }
            }
            }});
}

//metodo que se ejecuta cuando se cierra el listado de notificaciones que recibe el usuario
onMenuClosed(){
  this.menuabierto = false;
  this.paginacion.pagina = 1
  this.notificaciones = []
  this.sinNotificacion = false;
  this.finalNotificacion = false;
  // this.obtenerCantidadNotificacion();
  //this.obtenerNotificaciones();
}

//metodo que se ejecuta al llegar al final del scroll de la vista de listado de notificaciones que recibe el usuario

onScroll(index: number) {
  this.snackbar.dismiss();
  if(!this.menuabierto) return
  const end = this.viewport.measureScrollOffset('bottom') <= 3;
  if (index >= this.notificaciones.length - 1) {
    if(end){
      this.snackbar.dismiss();
      this.paginacion.pagina++;
      if (this.notificaciones.length < this.total)  {
        this.snackbar.dismiss();
        this.obtenerNotificaciones();
      } else {
        this.sinNotificacion = false;
        this.finalNotificacion = true;
      }
    }
  }
}

//Funcion para que al hacer click a una notificacion te lleve a la ruta que viene en su componente
itemNotificacion(e: any){
  this.redireccion = '/entidad/solicitud_credito/lista'
  if(e.componente === '/solicitud/credito/analisis/manual'){
    this.router.navigate(['entidad/procesamiento/solicitud_de_credito_pendiente']);
  }
  if(e.componente === '/entidad/solicitud_credito/lista'){
    this.router.navigate([this.redireccion]);
  }
  if(e.component !== '/entidad/solicitud_credito/lista' && e.componente !== '/solicitud/credito/analisis/manual'){
    this.router.navigate(['entidad/notificaciones/notificaciones']);
  }
}

////////////////////////////////CONFIGURACION DE MENSAJERIA PUSH//////////////////////


requestPermission(){
  this.afMessaging.requestPermission
  .pipe(mergeMapTo(this.afMessaging.tokenChanges))
  .subscribe(
    (token) => {
      //console.log('Permission granted! Save to the server', token );
    },
    (error) => {
      console.error(error);
    }
  );
}

getToken(){
  this.afMessaging.getToken.subscribe(res => console.log('token: ', res));
}

//Obtener la cantidad de notificaciones se ejecuta cada 15 segundos
timerCantidadNotificacion(){
  setInterval(() => {
    this.obtenerCantidadNotificacion()
  }, 60000); // 10000 milisegundos = 10 segundos
}

}
